import api, { ValidateAxiosError } from '@/modules/api.service';
import { ConfiguracoesDto } from '@/api.types';
import { Endpoints } from '@/shared/constants/endpoints';

/**
 * Invalida o cache do servidor (ex.: listagem de comarcas).
 * Requer permissão ADMIN_ACTIONS.
 */
export async function invalidateCache(): Promise<string> {
  return api
    .post(Endpoints.CONFIG + '/cache/invalidate')
    .then((res) => res.data?.message ?? 'Cache invalidado com sucesso.')
    .catch((error) => ValidateAxiosError<string>(error, 'Falha ao invalidar cache.'));
}

export async function readConfiguracoes(): Promise<ConfiguracoesDto[]> {
  return api
    .get(`${Endpoints.APP}/configuracoes`)
    .then((res) => res.data)
    .catch((error) => ValidateAxiosError<ConfiguracoesDto[]>(error, 'Falha ao carregar configurações.'));
}

export async function updateConfiguracao(chave: number, valor: string): Promise<ConfiguracoesDto> {
  return api
    .put(`${Endpoints.APP}/configuracoes/${chave}`, { valor })
    .then((res) => res.data)
    .catch((error) => ValidateAxiosError<ConfiguracoesDto>(error, 'Falha ao salvar configuração.'));
}
